import { connect } from 'react-redux';
import UserPreview from '../../../components/dashboards/preview/UserPreview';
import { getConfig } from '../../../utils/table';
import {
  getMetainf,
  getProjectZoneId,
  getUnitsExecutionState,
} from '../../../reducers/analyticsApp';

const mapStateToProps = (state, { unit }) => {
  const unitExecute = getUnitsExecutionState(state)[unit.id];
  const timezone = getProjectZoneId(state);
  const metainf = getMetainf(state);

  return {
    tableConfig: getConfig(unitExecute.events, metainf, timezone),
  };
};

export default connect(mapStateToProps)(UserPreview);
